import React from "react";
import AvailablityStatus from "../AvailablityStatus";
import locationIcon from "../../assets/icons/location_icon.svg";

interface CientProfileCardProps {
  name: string;
  title?: string;
  job_description?: string;
  availability_status?: string;
  image_url?: string;
  location?: string;
  availableFrom?: string;
}

const ProfileDetailCard: React.FC<CientProfileCardProps> = ({
  name,
  title,
  job_description,
  image_url,
  location,
  availability_status,
  availableFrom,
}) => {
  const availability = availability_status || "";
  return (
    <div className="break-normal w-full md:w-[210px] flex-wrap flex">
      <div className="py-4 w-full ">
        <div className="w-[100px] h-28 md:w-full md:h-[220px] mt-2">
          <img
            src={image_url}
            alt={name}
            className="object-cover w-[100%] h-[100%] "
          />
        </div>
        <div>
          <div className="flex flex-wrap mt-4 items-end">
            <h6 className="font-medium text-[16px] pr-1">{name},</h6>
            <h6 className="text-[13px] text-gray-500 pb-[2px]">{title}</h6>
          </div>
          <p className="border-t text-[13px] md:text-[12px] mt-3 pt-4">{job_description}</p>
        </div>

        <div className="flex items-start md:block border-t pt-4 mt-4">
          {availability && (
            <AvailablityStatus
              availability={availability}
              availableFrom={availableFrom}
            />
          )}

          {location && (
            <div className="flex pl-5 md:mt-3 md:pl-[3px]">
              <img src={locationIcon} width={12} alt="location_icon" />
              <span className="text-[13px] pl-1">{location}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileDetailCard;
